// 时间处理
let formatDate = (time) => {
    let reg = /T/
    let result
    if (reg.test(time)){
        result = time.slice(0,10)+' '+ time.slice(11,19)
    }
    else {
        result = time
    }

    return result
}
// 客户类型
let typeHandle = (value) =>{
    let result = ''
    switch (value) {
        case 0:
            result = '车主'
            break
        case 1:
            result = '企业'
            break
        case 2:
            result = '散客'
            break
    }
    return result
}
// 渠道
let refererHandle = (value) => {
    let result = ''
    switch (value) {
        case 0:
            result = '小程序-车主'
            break
        case 1:
            result = '小程序-汽修厂'
            break
        case 2:
            result = '小程序-认证企业'
            break
        case 3:
            result = 'pc管理端'
            break
    }
    return result
}
export {
    formatDate,
    typeHandle,
    refererHandle
}
